import { api } from '../../lib/api.ts';

export interface RulePartyView { id: string; name: string; email: string; isActive: boolean }

export interface ReviewRule {
  id: string;
  isActive: boolean;
  sender: RulePartyView;
  reviewer: RulePartyView;
  createdAt: string;
}

export const reviewRulesApi = {
  list: () => api.get<{ rules: ReviewRule[] }>('/review-rules').then((r) => r.data.rules),
  create: (senderId: string, reviewerId: string) =>
    api.post<{ rule: ReviewRule }>('/review-rules', { senderId, reviewerId }).then((r) => r.data.rule),
  update: (id: string, patch: { isActive?: boolean; reviewerId?: string }) =>
    api.patch<{ rule: ReviewRule }>(`/review-rules/${id}`, patch).then((r) => r.data.rule),
  remove: (id: string) => api.delete(`/review-rules/${id}`).then(() => undefined),
};
